import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, setupData } = useAuth();
  const { showSuccess, showError } = useToast();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  // URL'deki hata parametresini kontrol et
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get('error');
    
    if (error === 'account_disabled') {
      showError('Hesabınıza erişilemiyor', 10000);
    } else if (error === 'session_expired') {
      showError('Oturumunuz sona erdi. Lütfen tekrar giriş yapın.', 6000);
    }
  }, [location, showError]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData);
      
      if (result.success) {
        showSuccess('Giriş başarılı! Yönlendiriliyorsunuz...', 1800); // 1.8 saniye göster
        // AuthContext 1.5 saniye sonra otomatik yönlendirecek
      } else {
        showError(result.error, 6000); // 6 saniye görünür kalsın
      }
    } catch (error) {
      showError('Beklenmeyen bir hata oluştu', 6000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800 flex flex-col">
      <div className="flex-grow flex items-center justify-center p-4">
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl p-8 w-full max-w-md border border-white/20">
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">🛍️</div>
          <h1 className="text-3xl font-bold text-white mb-2">Giriş Yap</h1>
          <p className="text-white/80">Shopify Ürün Yönetimi</p>
        </div>

        {setupData?.hasUsers && setupData?.loginEnabled === false && (
          <div
            className="mb-6 p-4 rounded-lg bg-amber-500/20 border border-amber-300/40 text-amber-50 text-sm text-center"
            role="status"
          >
            Normal kullanıcı girişi kapalı. Yalnızca yönetici hesapları giriş yapabilir.
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-white/90 text-sm font-medium mb-2">
              E-mail
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              autoFocus
              autoComplete="off"
              className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent backdrop-blur-sm"
              placeholder="ornek@email.com"
            />
          </div>

          <div>
            <label className="block text-white/90 text-sm font-medium mb-2">
              Şifre
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="off"
              className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent backdrop-blur-sm"
              placeholder="••••••••"
            />
            <div className="mt-2 text-right">
              <Link
                to="/forgot-password"
                className="text-sm text-white/90 hover:text-white underline"
              >
                Şifremi unuttum
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-6 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-transparent transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                Giriş yapılıyor...
              </div>
            ) : (
              'Giriş Yap'
            )}
          </button>
        </form>

        <div className="text-center mt-6">
          <p className="text-white/80 text-sm">
            Hesabınız yok mu?{' '}
            {setupData?.registerEnabled ? (
              <button
                onClick={() => navigate('/register')}
                className="text-white font-medium hover:text-blue-200 transition-colors underline"
              >
                Kayıt Ol
              </button>
            ) : (
              <span className="text-white/60">
                Kayıt kapalı
              </span>
            )}
          </p>
        </div>
      </div>
      </div>
    </div>
  );
};

export default LoginPage;
